












































































































































































































import Vue from 'vue';
import { BButton, BFormCheckbox, BFormInput } from 'bootstrap-vue';
import Draggable from 'vuedraggable';

import EditCardDropdown, { Option } from '@/components/cards/EditCard/components/EditCardDropdown.vue';
import RichText from '@/components/rich_text/RichText.vue';
import { mapActions, mapGetters } from '@/state/modules/survey_builder';
import { isQuestionTypeAdditionalText } from '@/state/modules/survey_builder/helpers';

import QuestionEditOption from './QuestionEditOption.vue';
import QuestionEditCondition from './QuestionEditCondition.vue';
import QuestionEditMapping from './QuestionEditMapping.vue';

export default Vue.extend({
  name: 'QuestionEdit',
  components: {
    BButton,
    BFormCheckbox,
    BFormInput,
    Draggable,

    RichText,
    EditCardDropdown,
    QuestionEditOption,
    QuestionEditCondition,
    QuestionEditMapping,
  },
  computed: {
    ...mapGetters({
      question: 'editQuestion',
      questionTypes: 'questionTypes',
      isTypeValid: 'isEditQuestionTypeValid',
      isTitleValid: 'isEditQuestionTitleValid',
      isWeightValid: 'isEditQuestionWeightValid',
      isOptionsValid: 'isEditQuestionOptionsValid',
      hasOptions: 'editQuestionHasOptions',
      hasWeight: 'editQuestionHasWeight',
      pages: 'pages',
      isVisibleAlways: 'editQuestionIsVisibleAlways',
      isVisibleConditional: 'editQuestionIsVisibleConditional',
      conditionQuestions: 'editQuestionConditionQuestions',
      featureFlags: 'flags',
    }),

    questionTypeOptions(): Option[] {
      return this.questionTypes.map(item => ({
        value: item.type,
        label: item.name,
      }));
    },
    hasAdditionalText(): boolean {
      return isQuestionTypeAdditionalText(this.question);
    },
    questionPageOptions(): Option[] {
      return [
        ...this.pages.map(page => ({
          value: `${page.page}`,
          label: `${page.page}`,
        })),
        {
          value: 'new',
          label: '+ New empty page',
        },
      ];
    },
    showQuestionMappings() {
      return this.featureFlags && this.featureFlags.vendor_risk_phase_1;
    },
  },
  methods: {
    ...mapActions({
      setType: 'setQuestionType',
      setTitle: 'setQuestionTitle',
      setDescription: 'setQuestionDescription',
      setRequired: 'setQuestionRequired',
      setWeight: 'setQuestionWeight',
      setPage: 'setQuestionPage',
      setQuestionPage: 'setQuestionPage',
      addOption: 'addQuestionOption',
      setVisibleAlways: 'setQuestionVisibleAlways',
      setVisibleConditional: 'setQuestionVisibleConditional',
      addCondition: 'addQuestionCondition',
      setOptionsOrder: 'setQuestionOptionsOrder',
      duplicateQuestion: 'duplicateQuestion',
    }),
  },
});
